import {useAppSelector} from "@Hooks/selector/useAppSelector";
import useHandleCheckOrderError from "@CheckOrder/features/modals/hooks/useHandleCheckOrderError";
import {isEmpty} from "@Array/isEmpty";

/**
 * Dialog components renders even if dialog.open is not yet true.
 * That's why this hook checks whether the data for the modal exists, and if it does not it mimics the static data
 */
export default function useGetPriceChangeData() {
    const {
        checkOrderUserMessages,
    } = useAppSelector((state) => state?.checkOrder)

    const {handleError} = useHandleCheckOrderError()

    if (isEmpty(checkOrderUserMessages)) {
        return {
            message: "",
            title: "",
            btnText: "",
            oldPrice: null,
            newPrice: null,
            passengersNum: null,
            handleClick: () => {},
        }
    }

    const {
        0: {
            error: {
                userMessage,
                deliveryType,
                messageTitle,
                okBtnText,
            },
            additionalData,
        },
    } = checkOrderUserMessages

    const {
        submittedPrice,
        newPrice,
        passengers,
    } = additionalData || {}

    const handleClick = () => {
        if (deliveryType === "reload_notice") {
            window.location.reload()
        } else {
            handleError(deliveryType === "alert")
        }
    }

    return {
        message: userMessage,
        title: messageTitle,
        btnText: okBtnText,
        oldPrice: submittedPrice,
        newPrice,
        passengersNum: passengers,
        handleClick,
    }
}